import { Icon } from '@weezevent/nacre';
import { React, main, observer, useTranslation } from '../..';
import { useMemo } from 'react';
import TicketCard, { TicketCardContent } from '../../../detail/components/ticket-card/ticketCard';
import { PreviewEmpty } from '../../../../sessions/components/previewEmpty';
import OrderSummary from './Order';
import SessionRate from './SessionRate';

const Summary = observer(() => {
    const { t } = useTranslation();
    const { hasSelection, selectedRates, hasSelectedSessions, selectedSessions, useSessions, sessions } = main;
    const title = t('attendees.addAttendees.previewEmptyTitle');
    const session = Object.entries(sessions);
    const rate = selectedRates[0]?.original_object?.name;
    const selection = useSessions ? hasSelectedSessions && hasSelection : hasSelection;

    const filteredSession = useMemo(() => {
        if (hasSelectedSessions) {
            return session.find(item => item[1].value === selectedSessions)[1].text;
        }
    }, [selectedSessions, session]);

    if (!selection) {
        return <PreviewEmpty title={title} icon={<Icon name="cart" size="huge" />} />;
    }
    return (
        <TicketCard>
            <OrderSummary />
            {useSessions ? <SessionRate session={filteredSession} rate={rate} /> : <TicketCardContent>{rate}</TicketCardContent>}
        </TicketCard>
    );
});

export default Summary;
